module.exports = __webpack_public_path__ + "img/jr-icon-uildingsl.cb183335.png";